var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7857 9.96429H9.96429V14.7857C9.96429 15.3161 9.53036 15.75 9 15.75C8.46964 15.75 8.03571 15.3161 8.03571 14.7857V9.96429H3.21429C2.68393 9.96429 2.25 9.53036 2.25 9C2.25 8.46964 2.68393 8.03571 3.21429 8.03571H8.03571V3.21429C8.03571 2.68393 8.46964 2.25 9 2.25C9.53036 2.25 9.96429 2.68393 9.96429 3.21429V8.03571H14.7857C15.3161 8.03571 15.75 8.46964 15.75 9C15.75 9.53036 15.3161 9.96429 14.7857 9.96429Z",
    fill: "#353434",
    stroke: "#F6F6F6",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddProduct);
export default __webpack_public_path__ + "static/media/add-product.bfb2233376d5e8cbb64c50072e8f3e04.svg";
export { ForwardRef as ReactComponent };